import { RtError } from '@recruitee/utils';

export class PdfViewerConfigNotProvidedError extends RtError {
  constructor() {
    super('PdfViewerConfigNotProvidedError', 'Config for PdfViewer not provided');
  }
}
